var _mask, _g, _mask2, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGrvt8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    fill: "none",
    viewBox: "0 0 10 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2162_23966",
    x: 3,
    y: 4,
    width: 5,
    height: 4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.2891 4.7793c0 0.32327 0.11483 0.70309 0.35382 0.97994 0.26206 0.28917 0.60297 0.51448 1.0364 0.67232l-2.7163 1.2123c-1.073-0.72866-1.6642-1.6818-1.6642-2.8646h2.9902z",
    fill: "url(#paint0_linear_2162_23966)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.0001 -1)",
    mask: "url(#mask0_2162_23966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.2891 4.7793c0 0.32327 0.11483 0.70309 0.35382 0.97994 0.26206 0.28917 0.60297 0.51448 1.0364 0.67232l-2.7163 1.2123c-1.073-0.72866-1.6642-1.6818-1.6642-2.8646h2.9902z",
    fill: "#fff"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2162_23966",
    x: 8,
    y: 7,
    width: 6,
    height: 5,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.19 8.8874c0.5353 0.66883 0.8102 1.416 0.8102 2.229l-2.9945-0.2083c0-0.3446-0.12156-0.6612-0.38768-0.96353l-0.01053-0.01238c-0.26227-0.31877-0.61305-0.5633-1.0686-0.7307l-0.00616-0.00227-0.33781-0.12883 2.8261-1.2458c0.4594 0.30197 0.8507 0.65562 1.169 1.0627z",
    fill: "url(#paint1_linear_2162_23966)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.0001 -1)",
    mask: "url(#mask1_2162_23966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.19 8.8874c0.5353 0.66883 0.8102 1.416 0.8102 2.229l-2.9945-0.2083c0-0.3446-0.12156-0.6612-0.38768-0.96353l-0.01053-0.01238c-0.26227-0.31877-0.61305-0.5633-1.0686-0.7307l-0.00616-0.00227-0.33781-0.12883 2.8261-1.2458c0.4594 0.30197 0.8507 0.65562 1.169 1.0627z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.587 0.48309c0.71654-0.32647 1.525-0.48309 2.413-0.48309 0.88698 0 1.6903 0.15626 2.3962 0.48392 0.7065 0.32223 1.2714 0.76876 1.6757 1.3435 0.4227 0.57141 0.6292 1.2278 0.6292 1.9517 0 2.6153-2.7402 3.3653-4.7 4.2177l-0.53949 0.20479c-0.45556 0.1674-0.80633 0.41193-1.0686 0.7307l-0.01054 0.01238c-0.26612 0.30233-0.38786 0.61913-0.38786 0.96373 0 0.453 0.17278 0.7973 0.52597 1.0737l0.00514 0.0041c0.34697 0.279 0.82193 0.4388 1.4743 0.4388s1.1271-0.1598 1.4741-0.4388l0.00515-0.0041c0.35319-0.2764 0.52607-0.629 0.52607-1.0821l2.9946 0.2v0.0166c0 0.7686-0.2119 1.4613-0.6502 2.0588-0.4322 0.5892-1.032 1.0419-1.779 1.3633l-0.0072 0.0031c-0.75132 0.3104-1.6101 0.4581-2.5636 0.4581-0.95354 0-1.8121-0.1476-2.5635-0.458l-0.00725-3e-3c-0.74702-0.3214-1.3468-0.7742-1.779-1.3633-0.43834-0.5976-0.65019-1.2903-0.65019-2.0589 0-0.8239 0.27436-1.5779 0.81222-2.2489 0.30549-0.38108 0.67131-0.71393 1.0941-0.99961 0.13197-0.08917 0.27501-0.1603 0.42216-0.22122l2.6704-1.1056 0.26165-0.09119c0.45139-0.17071 0.80027-0.40421 1.0624-0.69468 0.25125-0.27844 0.36494-0.57017 0.36494-0.88956 0-0.38635-0.14399-0.67264-0.43414-0.90146l-0.01267-0.01033c-0.28312-0.23847-0.67869-0.37919-1.241-0.37919-0.56173 0-0.96747 0.14055-1.2656 0.38407-0.29919 0.24438-0.44092 0.54949-0.44092 0.92098l-2.9946-0.10089c0-0.72257 0.19947-1.3784 0.60982-1.9505l0.00153-0.00214c0.41475-0.57159 0.97718-1.0183 1.6731-1.3417l0.00365-0.00168z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2162_23966",
    x1: 5.5,
    x2: 5.9349,
    y1: 5.5,
    y2: 7.0186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2162_23966",
    x1: 11,
    x2: 10,
    y1: 10,
    y2: 8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGrvt8);
export default __webpack_public_path__ + "static/media/logo-grvt8.ce6db3cfef3b1976dbfb99984f72590f.svg";
export { ForwardRef as ReactComponent };